import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  if (document.querySelector(".splide01")) {
    new Splide(".splide01", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      autoplay: true,
      interval: 3000,
      pauseOnHover: false,
      focus: 0,
    }).mount();
  }
  if (document.querySelector(".splide02")) {
    new Splide(".splide02", {
      perPage: 3,
      type: "loop",
      focus: 0,
      autoScroll: {
        speed: 2,
      },
    }).mount({ AutoScroll });
  }
  if (document.querySelector(".splide03")) {
    new Splide(".splide03", {
      perPage: 1,
      autoplay: true,
      type: "fade",
      rewind: true,
      focus: 0,
      interval: 3000,
      speed: 1000,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: 2,
      },
    }).mount({ AutoScroll });
  }
  if (document.querySelector(".splide04")) {
    new Splide(".splide04", {
      autoplay: true,
      type: "loop",
      rewind: true,
      pauseOnHover: false,
      interval: 2000,
      speed: 1000,
      perPage: 3,
      focus: "center",
      updateOnMove: true,
      pagination: false,
      breakpoints: {
        768: {
          perPage: 1,
        },
      },
    }).mount();
  }
}